/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global message_email */

var WPMember = { };

( function ( $ ) {

	WPMember.signupModal = $( '#SignupModal' );
	WPMember.loginModal = $( '#LoginModal' );
	WPMember.editProfileModal = $( '#EditProfileModal' );
	WPMember.pwdChangeModal = $( '#PwdChangeModal' );
	WPMember.pwdForgotModal = $( '#PwdForgotModal' );
	WPMember.loginForm = '';

	WPMember.signupInit = function ( ) {
		var origContent = this.signupModal.find( '.mb-form' ).html( );
		this.signupModal.on( 'show.bs.modal', function ( ) {
			$( this ).find( 'form' ).attr( 'action', $( this ).data( 'page' ) );
			WPMember.signupSubmit( );
			WPMember.loginModal.modal( 'hide' );
		} );
		this.signupModal.on( 'hidden.bs.modal', function ( ) {
			$( this ).find( '.mb-form' ).html( origContent );
		} );
	};

	WPMember.signupSubmit = function ( ) {
		var container = this.signupModal.find( '.mb-form' );
		var loader = this.signupModal.find( '.loader' );
		var form = this.signupModal.find( '#wpmem_reg form' );
		var validEmail = false;
		var nextButton = form.find( '.next-step-btn' );
		var submitButton = form.find( 'input[type="submit"]' );
		var errorMessage = this.signupModal.find( '#errorMessage' );
		var required_err = 'This field is required.';
		var email_err = 'Please enter a valid email address.';
		var equalTo_err = 'Please enter the same value again.';

		submitButton.hide( );

		var validateStepTwo = function ( e ) {
			e.preventDefault( );
			if ( form.valid( ) ) {
//				console.log( 'STEP 2 valid' );

				loader.show( );

				$.post( {
					url: $( this ).attr( 'action' ),
					data: $( this ).serialize( ),
					success: function ( response ) {
						container.append( '<div style="display:none;">' + response + '</div>' );

						var loginForm = container.find( '#wpmem_login form' );

						loginForm.find( '#log' ).val( form.find( '#user_email' ).val() );
						loginForm.find( '#pwd' ).val( form.find( '#password' ).val() );
						loginForm.find( 'input[name="redirect_to"]' ).val( window.location.href );

						dataLayer.push( {
							'event': 'Conversion event',
							'conversionType': 'Academy signup'
						} );

						loginForm.submit();
					}
				} );
			} else {
//				console.log( 'STEP 2 invalid' );
			}
		};

		var validateStepOne = function ( e ) {
			if ( e !== undefined ) {
				e.preventDefault( );
			}

			if ( form.valid( ) && validEmail ) {
//				console.log( 'STEP 1 valid' );

				form.find( '.step-1' ).hide( );
				form.find( '.step-2' ).show( );
				form.find( '.next-step-btn' ).hide( );
				submitButton.show( );

				form.unbind( 'submit' );
				form.off( 'submit' );

				form.on( 'submit', validateStepTwo );
			} else {
//				console.log( 'STEP 1 invalid' );
			}
		};

		var obj = jQuery.parseJSON( errorMessage.val() );

		$.each( obj, function ( index, value ) {
			if ( index === 'required' ) {
				required_err = ( value !== '' ? value : required_err );
			}
			if ( index === 'email' ) {
				email_err = ( value !== '' ? value : email_err );
			}
			if ( index === 'equalTo' ) {
				equalTo_err = ( value !== '' ? value : equalTo_err );
			}
		} );


		form.validate( {
			onkeyup: false,
			rules: {
				user_email: {
					remote: {
						url: assessmentCall.ajaxurl,
						data: {
							action: 'unique_email'
						},
						method: 'post',
						beforeSend: function () {
							nextButton.off( 'click' );

							loader.show( );

							nextButton.text( nextButton.attr( 'data-alt-text' ) );
							nextButton.on( 'click', function ( e ) {
								e.preventDefault();
							} );
						},
						complete: function ( data ) {
//							console.log( data.responseJSON );

							loader.hide( );

							nextButton.text( nextButton.attr( 'data-text' ) );
							nextButton.on( 'click', validateStepOne );

							if ( data.responseJSON === 'true' ) {
								validEmail = true;
								validateStepOne();
							}
						}
					}
				},
				confirm_password: {
					equalTo: "#password"
				}
			},
			messages: {
				first_name: required_err,
				last_name: required_err,
				user_email: {
					required: required_err,
					email: email_err
				},
				company: required_err,
				job_title: required_err,
				password: required_err,
				confirm_password: {
					required: required_err,
					equalTo: equalTo_err
				}
			}
		} );

		form.unbind( 'submit' );
		form.off( 'submit' );

		form.on( 'submit', validateStepOne );
		form.find( '.next-step-btn' ).on( 'click', validateStepOne );
	};

	WPMember.loginInit = function () {
		var origContent = this.loginModal.find( '.mb-form' ).html();

		this.loginModal.on( 'show.bs.modal', function () {

			$( this ).find( 'form' ).attr( 'action', $( this ).data( 'page' ) );

			WPMember.loginSubmit();
			WPMember.signupModal.modal( 'hide' );
		} );

		this.loginModal.on( 'hidden.bs.modal', function () {
			$( this ).find( '.mb-form' ).html( origContent );
		} );

	};

	WPMember.loginSubmit = function () {
		var container = this.loginModal.find( '.mb-form' );
		var origContent = container.html();
		var loader = this.loginModal.find( '.loader' );
		var redirectURL = this.loginModal.data( 'redirect' );

		this.loginModal.find( '#wpmem_login form' ).submit( function ( e ) {
			e.preventDefault();

			loader.show();

			$.post(
					$( this ).attr( 'action' ),
					$( this ).serialize(),
					function ( response ) {
						container.hide();
						container.html( response );

						var msg = container.find( '#wpmem_msg' );

						if ( msg.length ) {
//            msg.find( 'p a' ).attr( 'href', redirectURL );

							$( '#LoginModalLink' ).click( function ( e ) {
								e.preventDefault();

								container.html( origContent );

								WPMember.loginSubmit();
							} );

							container.show();

							loader.hide();
						} else {
							container.html( origContent );
							container.show();

							window.location = redirectURL;
						}

						WPMember.loginSubmit();
					}
			);
		} );
	};

	WPMember.editProfileInit = function () {
		var origContent = this.editProfileModal.find( '.mb-form' ).html( );
		this.editProfileModal.on( 'show.bs.modal', function () {
			$( this ).find( 'form' ).attr( 'action', $( this ).data( 'page' ) );
			WPMember.editProfileSubmit();
		} );

		this.editProfileModal.on( 'hidden.bs.modal', function () {
			$( this ).find( '.wpmem_msg' ).remove();
			$( this ).find( '.mb-form' ).html( origContent );
		} );
	};

	WPMember.editProfileSubmit = function () {
		var container = this.editProfileModal.find( '.mb-form' );
		var loader = this.editProfileModal.find( '.loader' );
		var form = this.editProfileModal.find( '#wpmem_reg form' );
		var submitButton = form.find( 'input[type="submit"]' );
		var errorMessage = this.editProfileModal.find( '#errorMessage' );
		var required_err = 'This field is required.';
		var email_err = 'Please enter a valid email address.';
		var equalTo_err = 'Please enter the same value again.';

		submitButton.hide( );

		var validateStepTwo = function ( e ) {
			e.preventDefault( );
			if ( form.valid( ) ) {
//				console.log( 'STEP 2 valid' );

				loader.show( );

				$.post( {
					url: $( this ).attr( 'action' ),
					data: $( this ).serialize( ),
					success: function ( response ) {
						container.html( response );

						WPMember.editProfileSubmit();
						WPMember.editProfileInit();

						window.location.reload();
					}
				} );
			} else {
//				console.log( 'STEP 2 invalid' );
			}
		};

		var validateStepOne = function ( e ) {
			if ( e !== undefined ) {
				e.preventDefault( );
			}

			if ( form.valid( ) ) {
//				console.log( 'STEP 1 valid' );

				form.find( '.step-1' ).hide( );
				form.find( '.step-2' ).show( );
				form.find( '.next-step-btn' ).hide( );
				submitButton.show( );

				form.unbind( 'submit' );
				form.off( 'submit' );

				form.on( 'submit', validateStepTwo );
			} else {
//				console.log( 'STEP 1 invalid' );
			}
		};

		var obj = jQuery.parseJSON( errorMessage.val() );

		$.each( obj, function ( index, value ) {
			if ( index === 'required' ) {
				required_err = ( value !== '' ? value : required_err );
			}
			if ( index === 'email' ) {
				email_err = ( value !== '' ? value : email_err );
			}
			if ( index === 'equalTo' ) {
				equalTo_err = ( value !== '' ? value : equalTo_err );
			}
		} );


		form.validate( {
			onkeyup: false,
			rules: {
				confirm_password: {
					equalTo: "#password"
				}
			},
			messages: {
				first_name: required_err,
				last_name: required_err,
				user_email: {
					required: required_err,
					email: email_err
				},
				company: required_err,
				job_title: required_err,
				password: required_err,
				confirm_password: {
					required: required_err,
					equalTo: equalTo_err
				}
			}
		} );

		form.unbind( 'submit' );
		form.off( 'submit' );

		form.on( 'submit', validateStepOne );
		form.find( '.next-step-btn' ).on( 'click', validateStepOne );
	};

	WPMember.pwdChangeInit = function () {
		var origContent = this.pwdChangeModal.find( '.mb-form' ).html();

		this.pwdChangeModal.on( 'show.bs.modal', function () {
			$( this ).find( 'form' ).attr( 'action', $( this ).data( 'page' ) );

			WPMember.pwdChangeSubmit();
		} );

		this.pwdChangeModal.on( 'hidden.bs.modal', function () {
			$( this ).find( '.wpmem_msg' ).remove();
			$( this ).find( '.mb-form' ).html( origContent );
		} );
	};

	WPMember.pwdChangeSubmit = function () {
		var container = this.pwdChangeModal.find( '.mb-form' );

		this.pwdChangeModal.find( '#wpmem_login form' ).submit( function ( e ) {
			e.preventDefault();

			$.post(
					$( this ).attr( 'action' ),
					$( this ).serialize(),
					function ( response ) {
						container.html( response );

						WPMember.pwdChangeSubmit();
					}
			);
		} );
	};

	WPMember.pwdForgotInit = function () {
		var origContent = this.pwdChangeModal.find( '.mb-form' ).html();

		this.pwdForgotModal.on( 'show.bs.modal', function () {
			$( this ).find( 'form' ).attr( 'action', $( this ).data( 'page' ) );

			WPMember.pwdForgotSubmit();
			WPMember.loginModal.modal( 'hide' );
		} );

		this.pwdForgotModal.on( 'hidden.bs.modal', function () {
			$( this ).find( '.wpmem_msg' ).remove();
			$( this ).find( '.mb-form' ).html( origContent );
		} );
	};

	WPMember.pwdForgotSubmit = function () {
		var container = this.pwdForgotModal.find( '.mb-form' );

		this.pwdForgotModal.find( '#wpmem_login form' ).submit( function ( e ) {
			e.preventDefault();

			$.post(
					$( this ).attr( 'action' ),
					$( this ).serialize(),
					function ( response ) {
						container.html( response );

						WPMember.pwdForgotSubmit();
					}
			);
		} );
	};

	$( document ).ready( function ( ) {
		WPMember.signupInit( );
		WPMember.loginInit( );
		WPMember.editProfileInit( );
		WPMember.pwdChangeInit( );
		WPMember.pwdForgotInit( );

//    var origContent = this.loginModal.find( '.mb-form' ).html();
//
//    WPMember.loginForm = origContent;
	} );
}
)( jQuery );
